import Transaction from '~/types/Transaction';
import { ActionKeys } from './constants';

export function fetchTransaction(transactionId: string) {
  return <const>{
    type: ActionKeys.FETCH_TRANSACTION,
    payload: {
      transactionId,
    },
  };
}

export function fetchTransactionSuccess(transaction: Transaction) {
  return <const>{
    type: ActionKeys.FETCH_TRANSACTION_SUCCESS,
    payload: {
      transaction,
    },
  };
}

export function fetchTransactionError() {
  return <const>{
    type: ActionKeys.FETCH_TRANSACTION_ERROR,
  };
}

export function sendEmailNotification(transactionId: string) {
  return <const>{
    type: ActionKeys.SEND_EMAIL_NOTIFICATION,
    payload: {
      transactionId,
    },
  };
}

export function sendEmailNotificationSuccess() {
  return <const>{
    type: ActionKeys.SEND_EMAIL_NOTIFICATION_SUCCESS,
  };
}

export function sendEmailNotificationError() {
  return <const>{
    type: ActionKeys.SEND_EMAIL_NOTIFICATION_ERROR,
  };
}

export function refundTransaction(transactionId: string) {
  return <const>{
    type: ActionKeys.REFUND_TRANSACTION,
    payload: {
      transactionId,
    },
  };
}

export function refundTransactionSuccess() {
  return <const>{
    type: ActionKeys.REFUND_TRANSACTION_SUCCESS,
  };
}

export function refundTransactionError() {
  return <const>{
    type: ActionKeys.REFUND_TRANSACTION_ERROR,
  };
}

export function updateSuccessfulTransactionsCount(count: number) {
  return <const>{
    type: ActionKeys.UPDATE_SUCCESSFUL_TRANSACTIONS_COUNT,
    payload: {
      count,
    },
  };
}

export type TransactionsActions =
  | ReturnType<typeof fetchTransaction>
  | ReturnType<typeof fetchTransactionSuccess>
  | ReturnType<typeof fetchTransactionError>
  | ReturnType<typeof sendEmailNotification>
  | ReturnType<typeof sendEmailNotificationSuccess>
  | ReturnType<typeof sendEmailNotificationError>
  | ReturnType<typeof refundTransaction>
  | ReturnType<typeof refundTransactionSuccess>
  | ReturnType<typeof refundTransactionError>
  | ReturnType<typeof updateSuccessfulTransactionsCount>;
